/**
 * @generated SignedSource<<324694718511a0ac55e750528b043ce2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ArticlesSearchContainer_query$data = {
  readonly articles: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly rowId: string;
        readonly " $fragmentSpreads": FragmentRefs<"ArticleSearchItem_article">;
      } | null;
    }>;
    readonly pageInfo: {
      readonly endCursor: any | null;
      readonly hasNextPage: boolean;
      readonly startCursor: any | null;
    };
    readonly totalCount: number;
  } | null;
  readonly " $fragmentType": "ArticlesSearchContainer_query";
};
export type ArticlesSearchContainer_query$key = {
  readonly " $data"?: ArticlesSearchContainer_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"ArticlesSearchContainer_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "category"
    },
    {
      "kind": "RootArgument",
      "name": "count"
    },
    {
      "kind": "RootArgument",
      "name": "cursor"
    },
    {
      "kind": "RootArgument",
      "name": "searchTerm"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": [
          "articles"
        ]
      }
    ]
  },
  "name": "ArticlesSearchContainer_query",
  "selections": [
    {
      "alias": "articles",
      "args": [
        {
          "kind": "Literal",
          "name": "capabilityFilter",
          "value": [
            "BASIC",
            "FULLY_FEATURED"
          ]
        },
        {
          "kind": "Variable",
          "name": "categoryFilter",
          "variableName": "category"
        },
        {
          "kind": "Variable",
          "name": "searchPlain",
          "variableName": "searchTerm"
        },
        {
          "kind": "Literal",
          "name": "sortBy",
          "value": "FIRST_PUBLICATION_DATE_DESC"
        },
        {
          "kind": "Literal",
          "name": "statusFilter",
          "value": "PUBLISHED"
        }
      ],
      "concreteType": "ArticlesConnection",
      "kind": "LinkedField",
      "name": "__ArticlesSearchContainer_articles_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticlesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Article",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rowId",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ArticleSearchItem_article"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "bfda9911c21ff7da7d63bd9f2ec18b59";

export default node;
